const SELECT_REQUEST = 'projects/select/request'
const SELECT_SUCCESS = 'projects/select/success'
const SELECT_FAILURE = 'projects/select/failure'
const UPDATE_REQUEST = 'projects/update/request'
const UPDATE_SUCCESS = 'projects/update/success'
const UPDATE_FAILURE = 'projects/update/failure'

export { SELECT_REQUEST, SELECT_SUCCESS, SELECT_FAILURE, UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE }
